/**
 * OAuth 시작 URL 헬퍼.
 *
 * ggc-be 엔드포인트 (ggc-be/src/api/modules/influencer-auth/routes.ts):
 *   GET /influencer/auth/youtube[?grantAnalytic=yes]
 *   GET /influencer/auth/twitch
 *   GET /influencer/auth/logout
 *   GET /influencer/auth/error/login  (BE 주도, FE 호출 없음)
 */

function isStagingBackend(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'influencer2-staging.ggcontent.com';
}

function resolveAuthServer(): string {
  if (import.meta.env.VITE_NEW_API_BASE_URL) return import.meta.env.VITE_NEW_API_BASE_URL;
  if (import.meta.env.VITE_NEW_API_PROXY_TARGET) return import.meta.env.VITE_NEW_API_PROXY_TARGET;
  if (import.meta.env.PROD) {
    if (isStagingBackend()) return 'https://api-staging.ggcontent.com';
    return 'https://api.ggcontent.com';
  }
  return 'https://api-staging.ggcontent.com';
}

interface UrlOptions {
  /**
   * true면 절대 URL 반환 (백엔드 호스트로 직접 이동).
   * false/생략이면 same-origin 상대 경로 — vite/배포 프록시 경유.
   */
  direct?: boolean;
}

interface YoutubeOptions extends UrlOptions {
  grantAnalytic?: boolean;
}

function withBase(direct: boolean | undefined): string {
  if (!direct) return '';
  return resolveAuthServer();
}

export function getYoutubeAuthUrl(options: YoutubeOptions = {}): string {
  const base = withBase(options.direct);
  const query = options.grantAnalytic ? '?grantAnalytic=yes' : '';
  return `${base}/influencer/auth/youtube${query}`;
}

export function getTwitchAuthUrl(options: UrlOptions = {}): string {
  return `${withBase(options.direct)}/influencer/auth/twitch`;
}

export function getLogoutUrl(options: UrlOptions = {}): string {
  return `${withBase(options.direct)}/influencer/auth/logout`;
}
